import * as types from './types';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { cloneDeep } from 'lodash';
import moment from 'moment';

const INITIAL_STATE = {
  report: null,
  loading: null,
  error: null,
  selectedCalendars: [],
  calendars: [],
  badEmailLetterHistoryIds: [],
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.MBE_NOTIFICATION_LETTERS_GET_CALENDARS:
      const data = payload
        .filter(
          f =>
            f.MbeComplete !== true &&
            f.MealExpirationDT !== null &&
            moment(f.MealExpirationDT).isAfter(moment())
        )
        .map(item => ({
          Id: item.Id,
          Description: item.Description,
          ExpirationDate: item.MealExpirationDT
            ? defaultDateFormat(item.MealExpirationDT)
            : null,
        }));

      const selectOnly = [];
      if (data.length === 1) {
        selectOnly.push(data[0].Id);
      }

      return {
        ...state,
        calendars: data,
        selectedCalendars: selectOnly,
      };

    case types.MBE_NOTIFICATION_LETTERS_CALENDAR_TOGGLE:
      let newItems = cloneDeep(state.selectedCalendars);
      if (payload.checked === true) {
        newItems.push(payload.id);
      } else {
        newItems = newItems.filter(x => x !== payload.id);
      }

      return {
        ...state,
        selectedCalendars: newItems,
      };

    case types.MBE_NOTIFICATION_LETTERS_CALENDAR_TOGGLE_ALL:
      const allCalendars = cloneDeep(state.calendars);

      if (payload === true) {
        return {
          ...state,
          selectedCalendars: allCalendars.map(x => x.Id),
        };
      } else {
        return { ...state, selectedCalendars: [] };
      }

    case types.MBE_NOTIFICATION_LETTERS_GET_BAD_EMAILS:
      return {
        ...state,
        badEmailLetterHistoryIds: payload,
      };

    case types.MBE_NOTIFICATION_LETTERS_CLEAR_BAD_EMAILS:
      const newBadEmails = state.badEmailLetterHistoryIds.filter(badEmail => {
        return !payload.includes(badEmail.Id);
      });
      return {
        ...state,
        badEmailLetterHistoryIds: newBadEmails,
      };

    case types.MBE_NOTIFICATION_LETTERS_PROCESS_LETTERS:
      const unprintedBadEmails = state.badEmailLetterHistoryIds.filter(
        badEmail => {
          return !payload.includes(badEmail.Id);
        }
      );
      return {
        ...state,
        badEmailLetterHistoryIds: unprintedBadEmails,
      };

    case types.MBE_NOTIFICATION_LETTERS_LOADING:
      return {
        ...state,
        loading: payload,
      };

    case types.MBE_NOTIFICATION_LETTERS_ERROR:
      return {
        ...state,
        error: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/mbenotification/state/letters/reducer.js